import React from 'react';

import { Container, Row } from 'react-bootstrap';
import {
  FaRegLightbulb, FaUserFriends, FaCalendar, FaCircle,
} from 'react-icons/fa';
import FeatureCard from '@/components/orgpage/FeatureCard';

function FeatureSection() {
  return (
    <div className="site-section" id="gray-background" style={{ borderBottom: '1px solid #EEEEEE', borderTop: '1px solid #EEEEEE' }}>
      <Container>
        <Row>
          <FeatureCard
            icon={<FaRegLightbulb />}
            title="Admin Dashboard"
            description={(
              <div>
                <p>
                  Easy to use dashboard showing each user’s matches and engagement levels
                </p>
                <p>
                  Ability to view match comments, schedule group activites, and manage upcoming events
                </p>
              </div>
)}
          />
          <FeatureCard
            icon={<FaUserFriends />}
            title="Access to a network of hundreds of fully vetted Bigs and Minis"
            description={(
              <div>
                <p>
                  Look through user profiles and
                  hand-pick matches or let us find the best matches
                  for you through our innovative interest-based matching system
                </p>
              </div>
                          )}
          />
          <FeatureCard
            icon={<FaCalendar />}
            title="Flexible and fully-planned group activities "
            description={(
              <div>
                <p>Let us take the hassle out of organizing group events through customizable, fully-virtual activities designed to keep users engaged</p>
                <p>Examples of events include Scattergories, concerts, classes, group socials, and more </p>
              </div>
                          )}
          />
          <FeatureCard
            icon={<FaCircle />}
            title="Fully accessible platform"
            description={(
              <div>
                <p>
                  With technology training and options for smartphones, regular phones, tablets, and computers,
                  we make sure that everyone can use our platform with ease.
                </p>
                <p>
                  Our mobile application and one-tap call options help users get connected to friends, matches, and family members with ease
                </p>
              </div>
                          )}
          />
        </Row>
      </Container>

    </div>
  );
}
export default FeatureSection;
